import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';

import { WpService } from '../service/wp.service'

@Component({
  selector: 'app-kurs',
  templateUrl: './kurs.component.html',
  styleUrls: ['./kurs.component.scss']
})
export class KursComponent implements OnInit {

  kurs: any;
  loaded: boolean;

  constructor(private wp: WpService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.kurs = undefined
    this.loaded = false;
    this.route.params.subscribe(data => {
      this.wp.get('course/' + data.id).subscribe(
        data => {
          this.kurs = data
          for(let i = 0; i < this.kurs.dates.length; i++){
            this.kurs.dates[i].date = new Date(this.kurs.dates[i].date)
          }
          console.log(this.kurs.dates.length)
          this.loaded = true;
          // if(this.page['blog']){
          //   this.page['blog']["post_content"] = this.page['blog']["post_content"].split('<!--more-->')[0]
          // }
        },
        error => {
          console.error(error)
        }
      )
    })
  }

}



// WEBPACK FOOTER //
// /home/leonhard/Projekte/braungardt/angular/src/app/kurs/kurs.component.ts